import Decimal from "decimal.js";
import { useLanguage } from "hooks/settings";
import { SupportedLanguage } from "src/store/api/generatedApi";

export const formatNumber =
  (language: SupportedLanguage) =>
  (decimalPlaces: number, fixed = false) =>
  (value?: number | null): string => {
    if (value === undefined || value === null) return "N/A";
    const decimal = new Decimal(value);
    const baseOptions = {
      maximumFractionDigits: decimalPlaces,
    };
    const options = fixed
      ? {
          minimumFractionDigits: decimalPlaces,
          ...baseOptions,
        }
      : baseOptions;

    const formatter = new Intl.NumberFormat(language, options);
    return formatter.format(
      decimal.toDecimalPlaces(decimalPlaces).toNumber() + 0
    );
  };

export const useFormatNumber = () => {
  const language = useLanguage();
  return (decimalPlaces: number, fixed = false) =>
    (value?: number | null): string => {
      return formatNumber(language as SupportedLanguage)(decimalPlaces, fixed)(
        value
      );
    };
};
